import { AES, Rabbit, RC4, RC4Drop, enc } from 'crypto-js';

export type EncAlgorithm = 'AES' | 'Rabbit' | 'RC4' | 'RC4Drop' | 'SHA256' ;
export type Encryption = {
  encrypt(value: string): string;
  decrypt(value: string): string;
};

const algorithms = {
  AES,
  Rabbit,
  RC4,
  RC4Drop,
};

export function getEncryption(
  encAlgorithm: EncAlgorithm,
  secretKey: string,
): Encryption {
  return {
    encrypt: (value: string): string => {
      return algorithms[encAlgorithm].encrypt(value, secretKey).toString();
    },
    decrypt: (value: string): string => {
      let data = algorithms[encAlgorithm]
        .decrypt(value, secretKey)
        .toString(enc.Utf8);
      if (data && data !== 'undefined' && data !== 'null') return data; else return null;
    },
  };
}
